import { supabase } from '../../lib/supabase';

/**
 * Write one line to the admin audit log.
 *
 * Six sections each carried their own copy of this, and all six wrote the
 * literal string 'admin' as the actor. So "Removed admin from @x" recorded
 * that an admin did it and never which one — the log could not answer the
 * only question you ask it.
 *
 * The actor is no longer sent from here at all. A BEFORE INSERT trigger
 * (20260818233000) overwrites it with the caller's identity from their JWT,
 * because "Admins can insert audit log" is WITH CHECK (true) and anything the
 * browser supplies is forgeable by anyone signed in. The placeholder below
 * exists only to satisfy the NOT NULL column; the database replaces it.
 *
 * Failures are surfaced rather than swallowed. One of the six copies ended in
 * `.catch(() => {})`, which is how an audit log quietly stops recording.
 */
export async function logAudit(action_type, entity_type, description, entity_id = null) {
  const { error } = await supabase.from('admin_audit_log').insert({
    actor: 'pending',          // replaced by trg_stamp_audit_actor
    action_type,
    entity_type,
    description,
    entity_id: String(entity_id ?? ''),
  });
  if (error) console.error('logAudit failed:', error.message);
  return { error };
}
